"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CheckboxIconWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CheckboxIconWrapper = _styledComponents["default"].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  margin-right: ", ";\n  ", "\n\n  svg {\n    height: ", ";\n    width: ", ";\n  }\n"])), _utils.getIconColor, function (_ref) {
  var theme = _ref.theme,
    hasLabel = _ref.hasLabel;
  return hasLabel && theme.checkboxMargin;
}, function (_ref2) {
  var isFocused = _ref2.isFocused,
    theme = _ref2.theme;
  return isFocused && "\n    border-radius: ".concat(theme.checkboxFocusBorderRadius, ";\n    box-shadow: 0 0 0 ").concat(theme.checkboxFocusBorderSize, " inset ").concat(theme.checkboxShadowColorFocus, ";\n  ");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.checkboxSize;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.checkboxSize;
});
exports.CheckboxIconWrapper = CheckboxIconWrapper;
var _default = CheckboxIconWrapper;
exports["default"] = _default;